import axios from 'utils/axios';
import { MAP_LIST } from 'utils/axios/endpoints';

export const handleGetMapList = async () => {
  const res = await axios.get(MAP_LIST);
  return res;
};
